export const sentryDsn =
    'https://e39fab12ad314e74af2e3bd40e5fe601@o251606.ingest.us.sentry.io/1444989';
export const sentryOrg = 'make-llc';
export const sentryProject = 'ihme-staff-portal';
